import React, { memo, useMemo, useCallback } from 'react';
import { ReactComponent as MenuSvg } from '@assets/icons/menu.svg';
import { ReactComponent as ArrowDownSvg } from '@assets/icons/arrow-down.svg';
import { Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useCurrentWorkspace } from '@hooks/workspace';
import { useSimpleCampaignsListQuery } from '@hooks/queries/campaign';

type SelectCampaignProps = {
  currentCampaignId: string;
};

export default memo(function SelectCampaign({
  currentCampaignId
}: SelectCampaignProps) {
  const navigate = useNavigate();
  const [currentWorkspace] = useCurrentWorkspace(false);

  const { data: campaignsList } = useSimpleCampaignsListQuery({
    params: {
      workspaceId: currentWorkspace?.id || ''
    }
  });

  const items = useMemo(() => {
    const _list = (campaignsList || []).map((it) => ({
      label: it.name,
      key: it.id
    }));
    return _list;
  }, [campaignsList]);

  const onCampaignChange = useCallback(
    ({ key }) => {
      navigate(`/campaigns/single/${key}`);
    },
    [navigate]
  );
  return (
    <div className="campaign_breadcrumbs__tag">
      <Dropdown
        overlayClassName="select-campaign-overlay"
        trigger={['click']}
        menu={{
          items,
          selectable: true,
          defaultSelectedKeys: [currentCampaignId],
          onClick: onCampaignChange
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <MenuSvg />
          <ArrowDownSvg />
        </div>
      </Dropdown>
    </div>
  );
});
